import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { ContentLayout1 } from '@components/content/components/content-layout-1/model';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-1',
  imports: [TitleComponent, ButtonComponent, ImageComponent],
  templateUrl: './content-layout-1.component.html',
  styleUrl: './content-layout-1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout1Component implements OnInit {
  readonly data = input.required<ContentLayout1>();
  title = signal<Title>(null!);

  ngOnInit(): void {
    const data = this.data();
    if (data.title) {
      this.title.set({
        level: 'H2',
        type: 'SLASH',
        color: 'GREY_LIGHT',
        text: data.title,
        weight: 500,
        align: {
          mobile: 'LEFT',
          desktop: 'LEFT',
        },
        size: {
          mobile: 'SPAN',
          desktop: 'SPAN',
        },
      });
    }
  }
}
